<template>
  <!--
      作者：kmdshop
      时间：2020-06-01
      描述：插件中心-必备证书-修改
    -->
    <el-dialog
    title="修改必备证书"
    :visible.sync="dialogVisible"
    @close="dialogFormVisible"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    width="50%"
  >

  <div class="product-add pb50">

    <el-form size="small" :model="form" ref="form" :rules="rules" label-width="100px">
      <div class="common-form">修改必备证书</div>

      <el-form-item label="必备证书名称" prop="name">
        <el-input v-model="form.name" placeholder="请输入必备证书名称" class="max-w460"></el-input>
      </el-form-item>
      
      <el-form-item label="价格" prop="price">
        <el-input v-model="form.price" placeholder="请输入价格" class="max-w460"></el-input>
      </el-form-item>
      
      <el-form-item label="目录" prop="ml_directory_id">
        <el-select v-model="form.ml_directory_id" placeholder="请选择目录" class="max-w460">
            <template v-for="jz in jzList">
              <el-option :value="jz.ml_directory_id" :key="jz.ml_directory_id" :label="jz.name"></el-option>
            </template>
        </el-select>
      </el-form-item>
      
      <!-- 文件上传区域（bannar） -->
      <el-form-item label="添加文件：" prop="bannar">
        <div class="draggable-list">
          <draggable class="wrapper" v-model="form.bannar">
            <transition-group>
              <div v-for="(item, index) in form.bannar" :key="item.file_id || index">
                <div class="item file-item">
                  <!-- 图片文件显示缩略图 -->
                  <template v-if="isImageFile(item.file_path)">
                    <img v-img-url="item.file_path" :alt="item.file_name || '文件预览'"/>
                  </template>
                  <!-- 非图片文件显示图标 -->
                  <template v-else>
                    <i class="el-icon-document file-icon"></i>
                    <div class="file-name">{{ getFileName(item.file_path) }}</div>
                  </template>
                  <a href="javascript:void(0);" class="delete-btn" @click.stop="deleteFile(index,'bannar')">
                    <i class="el-icon-close"></i>
                  </a>
                </div>
              </div>
            </transition-group>
          </draggable>
          <div class="item img-select" @click="openProductUpload('bannar')">
            <i class="el-icon-plus"></i>
          </div>
        </div>
        <div class="form-hint">支持上传PDF、Word、Excel、图片等格式文件，单个文件不超过10MB</div>
      </el-form-item>

      <!-- 图片上传区域 -->
      <el-form-item label="图片：" prop="image">
        <div class="draggable-list">
          <draggable class="wrapper" v-model="form.image">
            <transition-group>
              <div v-for="(item, index) in form.image" :key="item.file_id || index">
                <div class="item">
                  <img v-img-url="item.file_path" alt="图片预览"/>
                  <a href="javascript:void(0);" class="delete-btn" @click.stop="deleteFile(index,'album')">
                    <i class="el-icon-close"></i>
                  </a>
                </div>
              </div>
            </transition-group>
          </draggable>
          <div class="item img-select" @click="openProductUpload('album')">
            <i class="el-icon-plus"></i>
          </div>
        </div>
        <div class="form-hint">支持JPG、PNG、GIF格式图片，建议尺寸800×600像素</div>
      </el-form-item>

      <!-- 客服二维码上传区域 -->
      <el-form-item label="客服二维码：" prop="service_qrcode">
        <div class="draggable-list">
          <draggable class="wrapper" v-model="form.service_qrcode">
            <transition-group>
              <div v-for="(item, index) in form.service_qrcode" :key="item.file_id || index">
                <div class="item">
                  <img v-img-url="item.file_path" alt="客服二维码"/>
                  <a href="javascript:void(0);" class="delete-btn" @click.stop="deleteFile(index,'service_qrcode')">
                    <i class="el-icon-close"></i>
                  </a>
                </div>
              </div>
            </transition-group>
          </draggable>
          <div class="item img-select" @click="openProductUpload('service_qrcode')">
            <i class="el-icon-plus"></i>
          </div>
        </div>
      </el-form-item>

      <!-- 详情富文本 -->
       <el-form-item label="详情" prop="intro">
        <div class="edit_container">
          <Uediter v-model="form.intro" :text="ueditorIntro.text" :config="ueditorIntro.config" ref="ueIntro"></Uediter>
        </div>
      </el-form-item>  
      
      <!-- 报考详情富文本 -->
      <!-- <el-form-item label="报考详情" prop="bk_detail">
        <div class="edit_container">
          <Uediter v-model="form.bk_detail" :text="ueditorBk.text" :config="ueditorBk.config" ref="ueBk"></Uediter>
        </div>
      </el-form-item>   -->

      <el-form-item label="排序" prop="sort">
        <el-input v-model="form.sort" placeholder="请输入排序" class="max-w460"></el-input>
      </el-form-item>
       
      <!--提交-->
      <div class="common-button-wrapper">
        <el-button size="small" type="info" @click="cancelFunc">取消</el-button>
        <el-button size="small" type="primary" @click="onSubmit" :loading="loading">提交</el-button>
      </div>
    </el-form>
    
    <!-- 文件上传组件 -->
    <Upload 
      v-if="isProductUpload" 
      :config="{ 
        total: 9, 
        accept: getAcceptType(code),
        size: 10485760  // 10MB
      }" 
      :isupload="isProductUpload" 
      @returnImgs="returnProductImgsFunc"
      @close="isProductUpload = false"
    >
      上传文件
    </Upload>
  </div>
</el-dialog>
  
</template>

<script>
import Certificate_certificateApi from '@/api/certificate_certificate.js';
import Upload from '@/components/file/Upload';
import Categoryas from "@/components/categorya/index.vue";
import draggable from "vuedraggable";
import Uediter from '@/components/UE.vue';

export default {
  components: {
    Upload,
    Categoryas,
    draggable,
    Uediter
  },
  data() {
    return {
      /*是否上传文件*/
      isProductUpload: false,
      code: "album",
      
      /*富文本配置 - 分别为详情和报考详情配置独立实例*/
      ueditorIntro: {
        text: '',
        config: {
          initialFrameWidth: 400,
          initialFrameHeight: 300
        }
      },
      ueditorBk: {
        text: '',
        config: {
          initialFrameWidth: 400,
          initialFrameHeight: 300
        }
      },
      
      /*form表单数据*/
      form: {
        certificate_certificate_id: '',
        ml_directory_id: '',
        price: '',
        name: '',
        code: 'custom',
        image: [],       // 图片列表
        bannar: [],      // 文件列表
        service_qrcode: [], // 客服二维码
        sort: 50,
        intro: "",       // 详情
        bk_detail: ""    // 报考详情
      },
      
      loading: false,
      /*验证规则*/
      rules: {
        name: [{ required: true, message: '请输入必备证书名称', trigger: 'blur' }],
        price: [{ required: true, message: '请输入价格', trigger: 'blur' }],
        ml_directory_id: [{ required: true, message: '请选择目录', trigger: 'change' }],
        image: [{ required: true, message: '请上传图片', trigger: 'change' }],
        bannar: [{ required: true, message: '请添加文件', trigger: 'change' }],
        service_qrcode: [{ required: false, message: '请上传客服二维码', trigger: 'change' }],
        intro: [{ required: true, message: '请填写详情', trigger: 'blur' }],
        bk_detail: [{ required: true, message: '请填写报考详情', trigger: 'blur' }]
      },
      
      jzList: [],
      dialogVisible: false,
      iscategorya: false,
      excludeIds: []
    };
  },
  
  created() {
    this.dialogVisible = this.open_add;
    this.getJzList();
    this.getDetail();
  },
  
  props: ["open_add", "certificate_certificate_id"],
  
  methods: {
    // 获取目录列表
    getJzList() {
      Certificate_certificateApi.getJzList()
        .then(res => {
          if (res && res.data && res.data.data) {
            this.jzList = res.data.data;
          } else {
            this.$message.error('获取目录列表失败');
            this.jzList = [];
          }
        })
        .catch(error => {
          console.error('获取目录列表出错:', error);
          this.$message.error('获取目录列表失败，请稍后重试');
        });
    },

    // 获取详情数据
    getDetail() {
      let self = this;
      Certificate_certificateApi.detail({ 
        certificate_certificate_id: self.certificate_certificate_id 
      }, true)
        .then(res => {
          if (res && res.data) {
            self.form = {
              ...res.data,
              // 确保数组存在，避免渲染错误
              image: res.data.image || [],
              bannar: res.data.bannar || [],
              service_qrcode: res.data.service_qrcode || []
            };
            
            // 初始化富文本内容
            self.ueditorIntro.text = res.data.intro || '';
          } else {
            this.$message.error('获取详情失败');
          }
          self.loading = false;
        })
        .catch(error => {
          console.error('获取详情出错:', error);
          this.$message.error('获取详情失败，请稍后重试');
          self.loading = false;
        });
    },

    chooseCategory() {
      this.iscategorya = true;
    },

    /*关闭弹窗*/
    dialogFormVisible(result) {
      this.$emit("close", { openDialog: false, "type": "" });
    },
    
    // 取消操作
    cancelFunc() {
      this.dialogFormVisible("error");
    },

    // 提交表单
    onSubmit() {
      let self = this;
      let form = self.form;
      
      // 获取富文本内容
      form.intro = this.$refs.ueIntro.getUEContent();
      // form.bk_detail = this.$refs.ueBk.getUEContent();
      
      self.$refs.form.validate(valid => {
        if (valid) {
          self.loading = true;
          Certificate_certificateApi.edit(form, true)
            .then(data => {
              self.loading = false;
              self.$message({
                message: data.msg || '修改成功',
                type: 'success'
              });
              self.dialogFormVisible("success");
            })
            .catch(error => {
              self.loading = false;
              self.$message.error('修改失败: ' + (error.message || '网络错误'));
              console.error('修改失败:', error);
            });
        }
      });
    },

    /*打开上传窗口*/
    openProductUpload(code) {
      this.isProductUpload = true;
      this.code = code;
    },

    /*根据上传类型获取accept*/
    getAcceptType(code) {
      switch(code) {
        case 'album':
          return 'image/*';
        case 'service_qrcode':
          return 'image/*';
        case 'bannar':
          return '*';
        default:
          return 'image/*';
      }
    },

    /*处理上传的文件/图片*/
    returnProductImgsFunc(files) {
      if (!files || files.length === 0) {
        this.isProductUpload = false;
        return;
      }
      
      // 验证文件类型
      const isValid = this.validateFiles(files);
      if (!isValid) {
        return;
      }
      
      // 根据类型添加到对应的数组
      switch(this.code) {
        case 'album':
          const imgs = this.form.image.concat(files);
          this.$set(this.form, "image", imgs);
          break;
        case 'service_qrcode':
          // 客服二维码只允许上传一张
          this.$set(this.form, "service_qrcode", [files[0]]);
          break;
        case 'bannar':
          const filesList = this.form.bannar.concat(files);
          this.$set(this.form, "bannar", filesList);
          break;
      }
      
      this.isProductUpload = false;
    },

    /*验证文件类型和大小*/
    validateFiles(files) {
      // 图片允许的格式
      const imgTypes = ["bmp", "jpg", "jpeg", "png", "gif"];
      // 文件允许的格式
      const fileTypes = [...imgTypes, "pdf", "doc", "docx", "xls", "xlsx", "ppt", "pptx"];
      
      for (const file of files) {
        // 获取文件扩展名
        const ext = this.getFileExtension(file.file_path).toLowerCase();
        
        // 验证文件类型
        if ((this.code === 'album' || this.code === 'service_qrcode') && !imgTypes.includes(ext)) {
          this.$message.error("图片类型有误，请选择bmp、jpg、jpeg、png、gif格式");
          return false;
        }
        
        if (this.code === 'bannar' && !fileTypes.includes(ext)) {
          this.$message.error("文件类型有误，支持PDF、Word、Excel、PPT、图片格式");
          return false;
        }
        
        // 验证文件大小 (如果有大小信息)
        if (file.size && file.size > 10485760) { // 10MB
          this.$message.error("文件大小不能超过10MB");
          return false;
        }
      }
      
      return true;
    },

    /*删除文件/图片*/
    deleteFile(index, code) {
      switch(code) {
        case 'album':
          this.form.image.splice(index, 1);
          break;
        case 'bannar':
          this.form.bannar.splice(index, 1);
          break;
        case 'service_qrcode':
          this.form.service_qrcode.splice(index, 1);
          break;
      }
    },

    /*获取文件扩展名*/
    getFileExtension(filePath) {
      if (!filePath) return '';
      const arr = filePath.split(".");
      return arr.length > 1 ? arr.pop() : '';
    },

    /*判断是否为图片文件*/
    isImageFile(filePath) {
      const ext = this.getFileExtension(filePath).toLowerCase();
      return ["bmp", "jpg", "jpeg", "png", "gif"].includes(ext);
    },

    /*获取文件名（不含路径）*/
    getFileName(filePath) {
      if (!filePath) return '未知文件';
      const arr = filePath.split("/");
      return arr.pop() || '未知文件';
    }
  }
};
</script>

<style>
.edit_container {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}

.ql-editor {
  height: 300px;
}

.draggable-list {
  display: flex;
  justify-content: flex-start;
  align-items: center;
  flex-wrap: wrap;
}

.draggable-list .wrapper > span {
  display: flex;
  justify-content: flex-start;
  flex-wrap: wrap;
}

.draggable-list .item {
  position: relative;
  width: 110px;
  height: 110px;
  margin-top: 10px;
  margin-right: 10px;
  border-radius: 8px;
  overflow: hidden;
  border: 1px solid #dddddd;
}

/* 文件项样式 */
.file-item {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  background-color: #f9f9f9;
}

.file-icon {
  font-size: 40px;
  color: #409eff;
  margin-bottom: 5px;
}

.file-name {
  font-size: 12px;
  color: #666;
  text-align: center;
  padding: 0 5px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  width: 90%;
}

.draggable-list .delete-btn {
  position: absolute;
  top: 0;
  right: 0;
  width: 16px;
  height: 16px;
  background: red;
  line-height: 16px;
  font-size: 16px;
  color: #ffffff;
  display: none;
  text-align: center;
  cursor: pointer;
  z-index: 10;
}

.draggable-list .item:hover .delete-btn {
  display: block;
}

.draggable-list .item img {
  position: absolute;
  top: 50%;
  left: 50%;
  -webkit-transform: translate(-50%, -50%);
  transform: translate(-50%, -50%);
  max-height: 100%;
  max-width: 100%;
}

.draggable-list .img-select {
  display: flex;
  justify-content: center;
  align-items: center;
  border: 1px dashed #dddddd;
  font-size: 30px;
  cursor: pointer;
}

.draggable-list .img-select i {
  color: #409eff;
}

/* 客服二维码预览样式 */
.qrcode-preview {
  margin-top: 15px;
  padding: 15px;
  background-color: #f9f9f9;
  border-radius: 8px;
  text-align: center;
}

.qrcode-tip {
  font-size: 14px;
  color: #666;
  margin-bottom: 10px;
  font-weight: bold;
}

.qrcode-image {
  width: 150px;
  height: 150px;
  border: 1px solid #ddd;
  border-radius: 8px;
  padding: 10px;
  background-color: #fff;
}

.qrcode-hint {
  margin-top: 10px;
  font-size: 12px;
  color: #8392a5;
}

/* 表单提示信息 */
.form-hint {
  margin-top: 5px;
  font-size: 12px;
  color: #8392a5;
}
</style>


// WEBPACK FOOTER //
// src/views/plus/certificate_certificate/index/part/edit.vue